import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { WhiteLabelService } from './white-label.service';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  private readonly ROUTES_WITH_CUSTOM_DESCRIPTION: string[] = ['login', 'register'];

  constructor(
    private translateService: TranslateService,
    private meta: Meta,
    private title: Title,
    private router: Router,
    private whiteLabelService: WhiteLabelService,
  ) {
  }

  public init() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.changeSiteDescriptions(event.urlAfterRedirects);
        this.changeSiteTitle(event.urlAfterRedirects);
      });
  }

  public changeSiteDescriptions(url: string) {
    const description = this.generatePageDescription(url);
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ property: 'og:description', content: description });
  }

  public changeSiteTitle(url: string) {
    this.title.setTitle(this.generatePageTitle(url));
  }

  private generatePageDescription(url: string) {
    const customDescriptionRoute: string = this.isPageWithNotStandardDescriptionAndTitle(url);
    if (customDescriptionRoute) {
      return `${this.translateService.instant(customDescriptionRoute) as string} - ${this.translateService.instant(`page_description_${customDescriptionRoute}`) as string
      }`;
    } else {
      return this.translateService.instant('page_description') as string;
    }
  }

  private generatePageTitle(url: string) {
    const customTitleRoute: string = this.isPageWithNotStandardDescriptionAndTitle(url);
    const wl = this.whiteLabelService.getState();
    const pageTitle = wl?.logoUrl ? 'page_title_wl' : 'page_title';
    if (customTitleRoute) {
      return `${this.translateService.instant(customTitleRoute) as string} - ${this.translateService.instant(pageTitle) as string}`;
    } else {
      return this.translateService.instant(pageTitle) as string;
    }
  }

  private isPageWithNotStandardDescriptionAndTitle(url: string) {
    return this.ROUTES_WITH_CUSTOM_DESCRIPTION.find((route: string) => url.includes(route));
  }
}
